module.exports = __webpack_public_path__ + "static/media/small-business-landscape.88e10657.jpg";